module.exports = __webpack_public_path__ + "static/media/headphones-alt.07d4b731.svg";